<template>
  <div>
    <div class="detail-info">
      <span class="info-title detail-class">操作：</span>
      <el-input
        v-model="value"
        class="drug-detail"
        placeholder=""
        type="textarea"
        resize="none"
        :rows="6"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DrugEdit",
  data() {
    return {
      value: ""
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    operationM() {
      return this.patient?.operationM;
    },
  },
  watch: {
    operationM: {
      handler(val) {
        this.value = val;
      },
      immediate: true
    },
  }
};
</script>

<style scoped lang="scss">
.detail-info {
  height: auto;
}

.drug-line ::v-deep {
  .el-select,
  .el-input {
    margin-right: 12px;
  }

  .el-input__inner {
    height: 32px;
    line-height: 32px;
    border-radius: 10px;
    margin-right: 12px;
  }

  .name-input {
    width: 200px;
  }

  .count-input {
    width: 60px;
  }

  .unit-input {
    width: 80px;
  }

  .body-input {
    width: 140px;
  }
}

.drug-lines {
  position: relative;
  display: flex;
  margin-bottom: 12px;
}

.add-drug-buttons {
  position: absolute;
  display: inline-block;
  left: 640px;
  bottom: 10px;
  cursor: pointer;

  img {
    vertical-align: bottom;
  }
}

.reduce-drug-buttons {
  position: absolute;
  display: inline-block;
  left: 680px;
  bottom: 10px;
  cursor: pointer;

  img {
    vertical-align: bottom;
  }
}

.detail-class {
  height: 16px;
  line-height: 16px;
  vertical-align: top;
}

.drug-detail {
  width: 640px;
  border-radius: 10px;
}
</style>
